module.exports = __webpack_public_path__ + "components/greenroom-articles/static/arrow-right-icon-c96d3a6d021873c9fce541d8caa7fe7a.svg";